import React from 'react';

import { Text } from '@thefarmersfront/kitchen';

import mainPageBackground from '../../assets/images/main_page_background.png';

import styles from './MainPage.module.scss';

const MainPage = () => {
  return (
    <div className={styles['page-wrapper']}>
      <div className={styles['content-wrapper']}>
        <div className={styles['main-content']}>
          <img src={mainPageBackground} alt="메인 페이지 배경이미지" width={280} height={268} />
          <Text className={styles['main-content-text']} color="tertiary" element="p" align="center">
            {'대시보드 준비 중입니다.\n멋진 모습으로 만나요!'}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
